export interface EditContentData {
  before: Record<string, any>;
  after: Record<string, any>;
}

export function parseEditContent(editContent?: string): EditContentData | null {
  if (!editContent || editContent.trim() === '') {
    return null;
  }

  try {
    const parsed = JSON.parse(editContent);
    if (parsed && typeof parsed === 'object' && 'before' in parsed && 'after' in parsed) {
      return parsed as EditContentData;
    }
    return null;
  } catch {
    return null;
  }
}

export function convertCamelCaseToTitleCase(fieldName: string): string {
  return fieldName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
}

export function formatFieldValue(value: any): string {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return String(value);
}
